import { render, staticRenderFns } from "./gameResultRewardTab.vue?vue&type=template&id=42f33f8f&lang=pug"
import script from "./gameResultRewardTab.vue?vue&type=script&lang=js"
export * from "./gameResultRewardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports